export default __webpack_public_path__ + "Erik Nelson.e54a851050f3fb4fe3cf.png";